import type { NamespaceSchema } from './types';

// Field paths match apps/api/src/modules/wallet/service.ts → getWalletSettings
// (snake_case keys preserved from the Phase B Payload-global migration).

export const walletSettings: NamespaceSchema = {
  namespace: 'wallet-settings',
  label: 'Wallet',
  description: 'In-app wallet (top-ups, refunds, credits). Off by default — flip on to expose wallet routes on the storefront.',
  sections: [
    {
      label: 'Activation',
      fields: [
        { kind: 'boolean', key: 'enabled', label: 'Wallet enabled site-wide', default: false },
        { kind: 'boolean', key: 'allow_mixed_payments', label: 'Allow wallet + card mixed payments', default: true, description: 'Off forces customer to pay either fully via wallet or fully via card per booking.' },
      ],
    },
    {
      label: 'Limits',
      description: 'Amounts in the primary currency (see Currency tab).',
      fields: [
        { kind: 'number', key: 'min_topup_amount', label: 'Minimum top-up', default: 10, min: 0 },
        { kind: 'number', key: 'max_topup_amount', label: 'Maximum top-up', default: 1000, min: 0 },
        { kind: 'number', key: 'max_balance', label: 'Maximum wallet balance', default: 5000, min: 0 },
      ],
    },
  ],
};
